// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2GysY","inputWrap":"styles_inputWrap__2PchV","input":"styles_input__2Oid3"};